export default __webpack_public_path__ + "static/media/assessment-detail.e3fce73d.png";